import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { screenerData } from "../Service/data";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import TableCell from "./TableCell";
import { Button } from "@mui/material";
import { createSearchParams, useNavigate } from "react-router-dom";

import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

// const columns = [
//   {
//     name: "Symbol",
//     selector: (row) => row.symbol,
//     sortable: true,
//     cell: (row, index, column, id) => {
//       return <TableCell id={id} ticker={row.symbol} />;
//     },
//   },
//   {
//     name: "Company Name",
//     selector: (row) => row.companyName,
//   },
//   {
//     name: "Market Cap",
//     selector: (row) => row.marketCap,
//     sortable: true,
//   },
//   {
//     name: "Industry",
//     selector: (row) => row.industry,
//   },
//   {
//     name: "Price",
//     selector: (row) => row.price,
//     sortable: true,
//   },
//   {
//     name: "Volume",
//     selector: (row) => row.volume,
//     sortable: true,
//   },
//   {
//     name: "Exchange",
//     selector: (row) => row.exchange,
//   },
//   {
//     name: "Country",
//     selector: (row) => row.country,
//     sortable: true,
//   },
// ];

const ScreenerTable = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();
  let [loading, setLoading] = useState(true);
  let [noFilters, setNoFilters] = useState(true);
  let [data, setData] = useState([]);

  const columns = useMemo(
    //column definitions...
    () => [
      {
        id: "info", //id used to define `group` column
        header: "Info",
        columns: [
          {
            accessorKey: "symbol", //accessorFn used to join multiple data into a single cell
            id: "symbol", //id is still required when using accessorFn instead of accessorKey
            header: "Symbol",
            size: 250,
            Cell: ({ renderedCellValue, row }) => {
              return (<TableCell id={row.id} ticker={row.getValue('symbol')} />);

            },
          },
          {
            id: "company",
            accessorKey: "companyName",
            header: "Company",
            size: 300,
          },
          {
            accessorKey: "marketCap",
            header: "Market Cap",
            size: 300,
          },
          {
            accessorKey: "industry",
            header: "Industry",
            size: 300,
          },
          {
            accessorKey: "price",
            header: "Price",
            size: 300,
          },
          {
            accessorKey: "volume",
            header: "Volume",
            size: 300,
          },
          {
            accessorKey: "exchange",
            header: "Exchange",
            size: 300,
          },
          {
            accessorKey: "country",
            header: "Country",
            size: 300,
          },
        ],
      },
      // {
      //   id: "general",
      //   header: "General Data",
      //   columns: [
      //     {
      //       accessorFn: (row) => row.data[0].open,
      //       header: "Open",
      //       filterFn: 'lessThan',
      //       size: 200,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].close, //hey a simple column for once
      //       header: "Close",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].high, //hey a simple column for once
      //       header: "High",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].low, //hey a simple column for once
      //       header: "Low",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].volume, //hey a simple column for once
      //       header: "Volume",
      //       size: 250,
      //     },
      //   ],
      // },
      // {
      //   id: "ema", //id used to define `group` column
      //   header: "Moving Average Data",
      //   columns: [
      //     {
      //       accessorFn: (row) => {
      //         if (row.data[0].ema20 !== null && row.data[0].ema20 !== undefined) {
      //           return `${row.data[0].ema20.toFixed(3)}`;
      //         }
      //         else {
      //           return "";
      //         }
      //       }, //accessorFn used to join multiple data into a single cell
      //       id: "ema20", //id is still required when using accessorFn instead of accessorKey
      //       header: "ema20",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => {
      //         if (row.data[0].ema50 !== null && row.data[0].ema50 !== undefined) {
      //           return `${row.data[0].ema50.toFixed(3)}`;
      //         }
      //         else {
      //           return "";
      //         }
      //       },
      //       id: "ema50", //id is still required when using accessorFn instead of accessorKey
      //       header: "ema50",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => {
      //         if (row.data[0].ema100 !== null && row.data[0].ema100 !== undefined) {
      //           return `${row.data[0].ema100.toFixed(3)}`;
      //         }
      //         else {
      //           return "";
      //         }
      //       },
      //       id: "ema100", //id is still required when using accessorFn instead of accessorKey
      //       header: "ema100",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => {
      //         if (row.data[0].ema200 !== null && row.data[0].ema200 !== undefined) {
      //           return `${row.data[0].ema200.toFixed(3)}`;
      //         }
      //         else {
      //           return "";
      //         }
      //       },
      //       id: "ema200", //id is still required when using accessorFn instead of accessorKey
      //       header: "ema200",
      //       size: 250,
      //     },
      //   ],
      // },
      // {
      //   id: "oscillators",
      //   header: "oscillators",
      //   columns: [
      //     {
      //       accessorFn: (row) => row.data[0].rsi.toFixed(3),
      //       header: "rsi",
      //       size: 200,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].macd.macd, //hey a simple column for once
      //       header: "macd",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].macd.signal, //hey a simple column for once
      //       header: "macd signal",
      //       size: 250,
      //     },
      //     {
      //       accessorFn: (row) => row.data[0].macd.divergence, //hey a simple column for once
      //       header: "macd divergence",
      //       size: 250,
      //     }
      //   ],
      // }
    ],
    []
    //end
  );

  const navigate = useNavigate();
  useEffect(() => {
    let query = searchParams.toString();
    if (query.length > 0) {
      setNoFilters(false);
      screenerData(query).then((data) => {
        setData(data);
        setLoading(false);
      });
    } else {
      setNoFilters(true);
      setLoading(false);
      setData([]);
    }
  }, [searchParams]);

  const handleViewClick = () => {
    const newSearchParams = searchParams.append('type', 'screener')
    navigate({
      pathname: "/multiview",
      search: createSearchParams(searchParams).toString(),
    });
  }
 
  const viewAction = () => (
    <Button variant="contained" style={{ marginRight: '20px' }} onClick={handleViewClick}>View</Button>
  )

  const table = useMaterialReactTable({
    columns,
    data,
    enableFilters: false,
    enableFullScreenToggle: false,
    renderTopToolbarCustomActions: viewAction,
    initialState: { 
      density: 'compact',
      columnPinning: { left: ['symbol', 'company'] },
    },
    enableStickyHeader: true,
  });

  return (
    <div style={{ width: "100%" }}>
      {loading && <CircularProgress />}
      {noFilters && <Typography>No filters are selected!</Typography>}
      {data !== null && data !== undefined && (
        <div style={{ width: '100%', marginBottom: '50px', overflow: 'auto' }}>
          <MaterialReactTable table={table} />
        </div>
      )}
    </div>
  );
};

export default ScreenerTable;
